import * as types from '../constants/actionTypes';

// ─── Fetch Bill Receipts (list) ───────────────────────────────────────────────
export const fetchBillsRequest = (filters = {}) => ({
  type: types.FETCH_BILLS_REQUEST,
  payload: filters,
});

export const fetchBillsSuccess = (data) => ({
  type: types.FETCH_BILLS_SUCCESS,
  payload: data,
});

export const fetchBillsFailure = (error) => ({
  type: types.FETCH_BILLS_FAILURE,
  payload: error,
});

// ─── Fetch Single Bill Receipt ────────────────────────────────────────────────
export const fetchBillRequest = (id) => ({
  type: types.FETCH_BILL_REQUEST,
  payload: id,
});

export const fetchBillSuccess = (data) => ({
  type: types.FETCH_BILL_SUCCESS,
  payload: data,
});

export const fetchBillFailure = (error) => ({
  type: types.FETCH_BILL_FAILURE,
  payload: error,
});

export const clearCurrentBill = () => ({
  type: types.CLEAR_CURRENT_BILL,
});

// ─── Record (Receive) a Bill ──────────────────────────────────────────────────
export const receiveBillRequest = (data) => ({
  type: types.RECEIVE_BILL_REQUEST,
  payload: data,
});

export const receiveBillSuccess = (data) => ({
  type: types.RECEIVE_BILL_SUCCESS,
  payload: data,
});

export const receiveBillFailure = (error) => ({
  type: types.RECEIVE_BILL_FAILURE,
  payload: error,
});

// ─── Verify a Bill ────────────────────────────────────────────────────────────
export const verifyBillRequest = (id, data = {}) => ({
  type: types.VERIFY_BILL_REQUEST,
  payload: { id, data },
});

export const verifyBillSuccess = (data) => ({
  type: types.VERIFY_BILL_SUCCESS,
  payload: data,
});

export const verifyBillFailure = (error) => ({
  type: types.VERIFY_BILL_FAILURE,
  payload: error,
});

// ─── Reject a Bill ────────────────────────────────────────────────────────────
export const rejectBillRequest = (id, data = {}) => ({
  type: types.REJECT_BILL_REQUEST,
  payload: { id, data },
});

export const rejectBillSuccess = (data) => ({
  type: types.REJECT_BILL_SUCCESS,
  payload: data,
});

export const rejectBillFailure = (error) => ({
  type: types.REJECT_BILL_FAILURE,
  payload: error,
});

// ─── Close a Bill ─────────────────────────────────────────────────────────────
export const closeBillRequest = (id, data = {}) => ({
  type: types.CLOSE_BILL_REQUEST,
  payload: { id, data },
});

export const closeBillSuccess = (data) => ({
  type: types.CLOSE_BILL_SUCCESS,
  payload: data,
});

export const closeBillFailure = (error) => ({
  type: types.CLOSE_BILL_FAILURE,
  payload: error,
});

// ─── Fetch Pending Bill Challans ──────────────────────────────────────────────
export const fetchPendingBillChallansRequest = (filters = {}) => ({
  type: types.FETCH_PENDING_BILL_CHALLANS_REQUEST,
  payload: filters,
});

export const fetchPendingBillChallansSuccess = (data) => ({
  type: types.FETCH_PENDING_BILL_CHALLANS_SUCCESS,
  payload: data,
});

export const fetchPendingBillChallansFailure = (error) => ({
  type: types.FETCH_PENDING_BILL_CHALLANS_FAILURE,
  payload: error,
});

// ─── Fetch PO Bill Summary ────────────────────────────────────────────────────
export const fetchPOBillSummaryRequest = (poId) => ({
  type: types.FETCH_PO_BILL_SUMMARY_REQUEST,
  payload: poId,
});

export const fetchPOBillSummarySuccess = (data) => ({
  type: types.FETCH_PO_BILL_SUMMARY_SUCCESS,
  payload: data,
});

export const fetchPOBillSummaryFailure = (error) => ({
  type: types.FETCH_PO_BILL_SUMMARY_FAILURE,
  payload: error,
});

// ─── Fetch PO 3-Way Reconciliation ───────────────────────────────────────────
export const fetchPOReconciliationRequest = (poId) => ({
  type: types.FETCH_PO_RECONCILIATION_REQUEST,
  payload: poId,
});

export const fetchPOReconciliationSuccess = (data) => ({
  type: types.FETCH_PO_RECONCILIATION_SUCCESS,
  payload: data,
});

export const fetchPOReconciliationFailure = (error) => ({
  type: types.FETCH_PO_RECONCILIATION_FAILURE,
  payload: error,
});

// ─── Fetch Bill Statistics ────────────────────────────────────────────────────
export const fetchBillStatisticsRequest = () => ({
  type: types.FETCH_BILL_STATISTICS_REQUEST,
});

export const fetchBillStatisticsSuccess = (data) => ({
  type: types.FETCH_BILL_STATISTICS_SUCCESS,
  payload: data,
});

export const fetchBillStatisticsFailure = (error) => ({
  type: types.FETCH_BILL_STATISTICS_FAILURE,
  payload: error,
});

// ─── UI Filters ───────────────────────────────────────────────────────────────
export const setBillFilters = (filters) => ({
  type: types.SET_BILL_FILTERS,
  payload: filters,
});

export const clearBillFilters = () => ({
  type: types.CLEAR_BILL_FILTERS,
});

export const clearBillError = () => ({
  type: types.CLEAR_BILL_ERROR,
});
